import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Home";
import Admin from "./Frontend/auth/Admin";
import "./App.css";

const App = () => {
  const isUserAuthenticated = () => {
    const sessionToken = localStorage.getItem("sessionToken");
    return sessionToken !== null;
  };

  return (
    <Router>
      <Routes>
        <Route
          path="*"
          element={isUserAuthenticated() ? <Home /> : <Admin />}
        />
      </Routes>
    </Router>
  );
};

export default App;
